import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getLocalizationScreenSizes({commit}) {
        return axios
            .get('/outdoors/outdoor-localization-screen-sizes')
            .then(response => {
                commit('GET_LOCALIZATION_SCREEN_SIZES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie wymiarów ekranów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createLocalizationScreenSize({ commit }, payload) {
        return axios
            .post('/outdoors/outdoor-localization-screen-sizes', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Wymiar ekranu został dodany.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie wymiaru ekranu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateLocalizationScreenSize({ commit }, payload) {
        return axios
            .put(`/outdoors/outdoor-localization-screen-sizes/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Wymiar ekranu został zedytowany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis nie powiódł się.')

                return Promise.reject(error)
            })
    },
    deleteLocalizationScreenSize({ commit }, id) {
        return axios
            .delete(`/outdoors/outdoor-localization-screen-sizes/${id}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Wymiar ekranu został usunięty.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie wymiaru nie powiodło się.')

                return Promise.reject(error)
            })
    },
}